<script setup>
import OfButton from '@dk.onlinefundraising/vue-utils/src/utils/OfButton.vue';
import OfAddClientModal from '../OfAddClientModal.vue';
import OfExportCampaignModal from '../OfExportCampaignModal.vue';
import { ref,defineEmits } from 'vue';
import { merchant, user } from '@/store';
import { setPage } from '@dk.onlinefundraising/onboarding-utils/src/pageHandler';
import { userAllowed } from '@/functions';

const openAddClient = ref(false);
const openExport = ref(false);

const emit = defineEmits(['getMerchants']);

function viewProfile() {

    merchant.value = {};

    setPage('profile');

}

</script>
<template>
    <div class=profile-wrap>
        <div class=profile-bar>
            <div class="avatar-wrap">
                <a v-if="userAllowed('READ_USER')" class="" @click.prevent="viewProfile">
                    <i class="dashboard-icon icon-profile"></i>
                    {{ user.name }}
                </a>
                <span v-else>
                     {{ user.name }}
                </span>
            </div>
            <div class="buttons">

              <OfButton v-if="userAllowed('EXPORT_SESSION')" text="Export" coloring="secondary" @click="openExport = true"/>

              <OfButton v-if="userAllowed('EXPORT_SESSION')" text="Add client" coloring="primary" @click="openAddClient = true"/>

            </div>
        </div>
    </div>

    <OfAddClientModal v-if="openAddClient" @close="openAddClient = false" @get-merchants="emit('getMerchants')"/>
    
    <OfExportCampaignModal v-if="openExport" @close="openExport = false"/>

</template>
<style scoped>
.profile-wrap {
    width: 100%;
}
.profile-bar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    max-width: 100%;
    top: 0;
    left: 0;
    right: 0;
    position: relative;
    padding: 0 30px;
    height: 72px;
    -webkit-box-shadow: 0 1px 0 0 #eaedf3;
    box-shadow: 0 1px 0 0 #eaedf3;
    background: #fff;
}
.avatar-wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.buttons {
    position: relative;
    display: flex;
    gap: 1rem;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-left: auto;
}
</style>